import React, { Component } from "react";
import './index.css';

class Search extends Component {
  constructor (props) {
    super();
    this.state = {}
  }

  render () {
    let closeIcon = null;
    if (this.props.searchKeyword !== '') {
      closeIcon =
        <i className="material-icons close" onClick={this.props.clearKeyword}>close</i>;
    }

    return (
      <div className="AS-search sheet">
        <i className="material-icons search">search</i>
        <input className="searchInput" type="text"
          placeholder="Search"
          value={this.props.searchKeyword}
          onChange={this.props.startSearch}
        />
        {closeIcon}
      </div>
    )
  }
}

export default Search;



// WEBPACK FOOTER //
// ./src/views/PickerView/components/Search/index.js